import { Loader } from '@calendly/ui/components/loader';
import { Container, ListContainer, LoadingContainer } from './styles';
import { useInfiniteScroll } from './use_infinite_scroll';

// The sentinel needs a non-zero height to be a reliable IntersectionObserver
// target; a zero-height element can fail to register an intersection.
const sentinelCss = "s1muurjg";
export const InfiniteScroll = ({
  items,
  onLoadMore,
  hasMore = false,
  isLoading = false
}) => {
  const {
    sentinelRef
  } = useInfiniteScroll({
    onLoadMore,
    hasMore,
    isLoading
  });
  return <Container>
      <ListContainer>
        {items}
      </ListContainer>
      <div ref={sentinelRef} className={sentinelCss} data-testid="scroll-sentinel" />
      {isLoading && <LoadingContainer>
          <Loader data-testid="meeting-list-loader" />
        </LoadingContainer>}
    </Container>;
};

require("./infinite_scroll.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./infinite_scroll.js");